module.exports = __webpack_public_path__ + "img/avatar.9a77a891.jpg";